import styles from './style.module.scss'
import logoImg from '../../assets/images/logo.png'
import packageJson from '../../../package.json';
import LogoutIcon from '@mui/icons-material/Logout';
import { useContext } from 'react';
import { ContextApi } from '../../context/contextApi';
import { useNavigate } from 'react-router-dom';

export function Header({
    openDrawer,
    setOpenDrawer
}) {
    let navigate = useNavigate();
    const {
        logOut,
        loggedUser
    } = useContext(ContextApi)

    function handleLogOut() {
        logOut()
        navigate('/login')
    }

    return (
        <head className={styles.containerHeader}>
            <img className={styles.imgLogo} src={logoImg} alt="Logo SurfView" />
            <span className={styles.barra}>|</span>
            <p>ADM</p>
            {loggedUser && 
            <div 
            className={styles.boxLogOut}
            title='Sair'
            onClick={() => handleLogOut()}
            >
                <LogoutIcon />
            </div>}
        </head>
    )
}